module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n  <h1>{{ \"USERS.CLIENT_LOGIN.TITLE\" | translate }}</h1>\n\n  <p>{{email}}</p>\n  <form name=\"loginForm\"  ng-submit=\"login(loginForm)\" class=\"login-panel text-left\" layout=\"column\" novalidate>\n    <div password model=\"fields.password\" form=\"loginForm\" autofocus=\"true\"></div>\n    <div flex class=\"text-left login-button\">\n      <button type=\"submit\" class=\"md-button md-raised md-primary\">\n        {{ 'COMMONS.LOGIN' | translate }}\n      </button>\n    </div>\n  </form>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client-login.html
// module id = 236
// module chunks = 0